import script from "./HrVirtualScroll.vue?vue&type=script&setup=true&lang=js"
export * from "./HrVirtualScroll.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QVirtualScroll from 'quasar/src/components/virtual-scroll/QVirtualScroll.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QVirtualScroll});
